import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signIn } from '../../services/auth/signIn';
import { toast } from 'react-hot-toast';

const MAX_LOGIN_ATTEMPTS = 10;

export function useLogin() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogin = async (email: string, password: string) => {
    setIsLoading(true);

    try {
      const result = await signIn(email, password, MAX_LOGIN_ATTEMPTS);
      
      if (result.error) {
        // Show specific error message
        const errorMessage = typeof result.error === 'string' 
          ? result.error 
          : 'Invalid email or password';
        toast.error(errorMessage);
        return false;
      }

      if (result.user && result.session) {
        toast.success('Welcome back!');
        // Get destination and promo code from location state
        const destination = location.state?.from || '/prestige-club';
        const promoCode = location.state?.promoCode;

        // If there's a promo code and destination is subscription, add promo code to URL
        if (destination === '/subscription' && promoCode) {
          navigate(`/subscription?promo=${promoCode}`, { replace: true });
        } else {
          navigate(destination, { replace: true });
        }
        return true;
      }

      toast.error('Unable to sign in. Please check your credentials and try again.');
      return false;
    } catch (error) {
      console.error('Login error:', error);
      const message = error instanceof Error 
        ? error.message 
        : 'An unexpected error occurred. Please try again.';
      toast.error(message);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleLogin
  };
}